import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import * as apiConfig from "../../api/config";
import PropTypes from "prop-types";
import "./Create.css";
import Spinner from "../common/Spinner";
import { getDirections, standardisePoint, getRouteClickedInsertionIndex } from "../../api/routeUtilitiesApi";
import MapSwitchControl from "./MapSwitchControl";
import geocoder from 'google-geocoder';
import $ from 'jquery';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/autocomplete.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/autocomplete';

function CreateRouteGoogleMapView({
    auth,
    mapVariant,
    centre,
    zoom,
    points,
    routeCreatorState,
    draftRoute,
    mapUpdated,
    addRoutePoints,
    deleteRoutePoint,
    moveRoutePoint,
    insertRoutePoint,
    setReCentreOnLoad,
    history,
    map,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);
    const [google, setGoogle] = useState(null);

    const mapRef = useRef(null);
    const locationRef = useRef(null);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);

    //var map;

    var routePoints = []; 
    var draftPolyline;
    var markers = [];
    var movingMarkerPosition;
    var movingMarkerNewPosition;
    var movingMarkerIndex; 
    var markerIsMoving = false;

    useEffect(() => {
        if (!google) {
            var GoogleMapsLoader = require('google-maps');
            GoogleMapsLoader.KEY = 'AIzaSyDuapJ8ilJP2mie5BKeZfP_xyeCGiJGJLI';

            GoogleMapsLoader.load(function (google) {

                setGoogle(google);

            });
        }

    }, []);

    useEffect(() => {
        if (google) {
            setUpMap(); 
            restoreRouteFromState();
            if (routeCreatorState.reCentreOnLoad) {
                reCentreMap();
                setReCentreOnLoad(false);
            }
        }
    }, [google])

    useEffect(() => {
        if (google) {
            if (!map) {
                setUpMap();
            }
            restoreRouteFromState();
            if (routeCreatorState.reCentreOnLoad) {
                reCentreMap();
                setReCentreOnLoad(false);
            }
        }
    }, [routeCreatorState.plotMode, routeCreatorState.createMode, draftRoute.future.length, mapVariant])

    function reCentreMap() {

        var latlngbounds = new google.maps.LatLngBounds();
        routePoints.map(point => {
            latlngbounds.extend(new google.maps.LatLng(point.lat, point.lng));
        });

        map.fitBounds(latlngbounds);
        mapUpdated({ centre: [map.center.lat(), map.center.lng()], zoom: map.zoom });
    }

    function restoreRouteFromState() {
        if (points.length > 0) {

            markers.map(marker => {
                marker.setMap(null);
            });

            var checkArray = [];
            points.map((point) => {
                checkArray.push({ lat: point.lat, lng: point.lng });
            })

            var newMarkers = []
            points.map((point, index) => {
                newMarkers.push(createMarker(point, index == 0))

                checkArray.map((p, idx) => {
                    if (p.lat === point.lat && p.lng === point.lng && index != idx) {
                        var newPoint = { lat: point.lat + 0.00001, lng: point.lng + 0.00001, ele: point.ele, dist: point.dist }
                        newPoint = standardisePoint(newPoint);
                        moveRoutePoint(newPoint, index)
                        points.splice(index, 1, newPoint);
                        checkArray.splice(index, 1, newPoint);
                    }
                });

                routePoints.push({ lat: point.lat, lng: point.lng })
            });
            markers = newMarkers;
            reDrawRoute(points);
           
        } else if (routeCreatorState.plotMode != "auto") {
            mapUpdated({ plotMode: "auto" });
        }
    }


    function setUpMap() {

        var mapOptions = {
            mapTypeControl: false,
            zoomControl: false,
            streetViewControl: true,
            streetViewControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
            draggableCursor: 'default'
        };

        var el = document.getElementById("google-map");
        map = new google.maps.Map(el, mapOptions);

        google.maps.event.addListener(map, 'tilesloaded', handleMapLoad);
        google.maps.event.addListener(map, 'click', handleMapClick);
        google.maps.event.addListener(map, 'zoom_changed', handleMapChanged);
        google.maps.event.addListener(map, 'center_changed', handleMapChanged);
        google.maps.event.addListener(map, 'maptypeid_changed', handleMapVariantChanged);

        map.setCenter({ lat: centre[0], lng: centre[1] });
        map.setZoom(zoom)

        if (mapVariant) {
            map.setMapTypeId(mapVariant);
        }
    }


    function handleMapLoad() {
        var geo = geocoder({
            key: apiConfig.GOOGLE_API_KEY,
            region: "uk"
        });

        var location = locationRef.current;
        $(location).autocomplete({
            source: function (request, response) {
                geo.find(request.term, function (err, res) {
                    var results = new Array();
                    if (res[0]) {
                        geocoder.firstItem = res[0];
                        for (var i = 0; i < res.length; i++) {
                            res[i].label = res[i].formatted_address;
                            results.push(res[i]);
                        }
                        response(results);
                    }
                    else {
                        response();
                    }
                });

            },
            select: function (event, ui) {
                $(location).val(ui.item.formatted_address);
                map.setCenter({ lat: ui.item.location.lat, lng: ui.item.location.lng });
                map.setZoom(14);
                mapUpdated({ zoom: 14, centre: [ui.item.location.lat, ui.item.location.lng], reprimeZoom: true  });
            }
        });

        var zoomIn = zoomInRef.current;
        $(zoomIn).unbind('click');
        $(zoomIn).click(() => {
            let zoom = map.getZoom();
            zoom = zoom + 1
            map.setZoom(zoom);
            mapUpdated({ zoom: zoom });
        })

        var zoomOut = zoomOutRef.current;
        $(zoomOut).unbind('click');
        $(zoomOut).click(() => {
            let zoom = map.getZoom();
            zoom = zoom - 1
            map.setZoom(zoom);
            mapUpdated({ zoom: zoom });
        })
    }


    function onSearch() {
        var geo = geocoder({
            key: apiConfig.GOOGLE_API_KEY,
            region: "uk"
        });
        var location = locationRef.current;
        geo.find($(location).val(), function (err, res) {
            if (res[0]) {
                geocoder.firstItem = res[0];
                map.setCenter({ lat: res[0].location.lat, lng: res[0].location.lng });
                map.setZoom(14);
                mapUpdated({ zoom: 14, centre: [res[0].location.lat, res[0].location.lng] });
            }
            else {
                alert('No Results Found!');
            }
        });
    }

    /*
    function onSetUserLocation() {
        if (navigator.geolocation) {
            setProcessing(true);
            navigator.geolocation.getCurrentPosition(setBrowserLocation, map);
        } 
    }

    function setBrowserLocation(position, map) {
        var centre = { lat: position.coords.latitude, lng: position.coords.longitude }; 
        map.setCenter(centre);
        map.setZoom(14);
        mapUpdated({ zoom: 14, centre: [centre.lat, centre.lng] });

        setProcessing(false);
    }
    */

    function clearMap() {
        if (draftPolyline.setMap) {
            draftPolyline.setMap(null);
        }
        if (markers) {
            markers.map(m => {
                m.setMap(null);
            })
        }
    }

    function handleMapClick(e) {
        if (routeCreatorState.createMode == "draw") {
            if (routePoints.length == 0) {
                var startPoint = standardisePoint({ lat: e.latLng.lat(), lng: e.latLng.lng() });
                addRoutePoints([startPoint]);
                routePoints.push(startPoint);
                var marker = createMarker(startPoint, true);
                markers.push(marker)
            }
            else {
                if (routeCreatorState.plotMode == "auto") {
                    getDirections(routePoints[routePoints.length - 1], { lat: e.latLng.lat(), lng: e.latLng.lng() }, routeCreatorState.autoMode).then(directions => {
                        directions.splice(0, 1); //take off start point
                        var pointsToAdd = [];
                        directions.map((point) => {
                            point = standardisePoint(point);
                            routePoints.map(p => {
                                if (p.lat === point.lat && p.lng === point.lng) {
                                    point.lat = point.lat + 0.00001;
                                    point.lng = point.lng + 0.00001;
                                    point = standardisePoint(point);
                                }
                            })
                            pointsToAdd.push(point);
                        })
                        addRoutePoints([...pointsToAdd]);
                        updateRoute([...pointsToAdd])
                    })

                } else {
                    var newPoint = { lat: e.latLng.lat(), lng: e.latLng.lng() }
                    newPoint = standardisePoint(newPoint);
                    addRoutePoints([newPoint]);
                    updateRoute([newPoint])
                }
            }
        }
    }

    function updateRoute(newPoints) {

        newPoints.map((point) => {

            routePoints.push(point);

            var marker = createMarker(point, false);
            markers.push(marker)
        })

        reDrawRoute(routePoints);

    }

    function reDrawRoute(points, pointMoving) {
        
        if (draftPolyline) {
           draftPolyline.setMap(null);
        }

        draftPolyline = new google.maps.Polyline({
            map: map,
            path: points,
            strokeColor: '#14a4ff',
            strokeOpacity: 1.0,
            strokeWeight: 2
        })

        google.maps.event.addListener(draftPolyline, 'click', insertPoint);
    }

    function insertPoint(e) {
        if (routeCreatorState.createMode == "edit") {
            var point = standardisePoint({ lat: e.latLng.lat(), lng: e.latLng.lng() });
            var index = getRouteClickedInsertionIndex(point, routePoints);
            if (index != -1) {

                routePoints.splice(index, 0, point);
                reDrawRoute(routePoints);

                var marker = createMarker(point, false);
                markers.push(marker)

                insertRoutePoint(point, index);
            }
        }
    }

    function createMarker(point, firstpoint) {
        var g = google.maps;
        var pointIcon = new g.MarkerImage(
            firstpoint ? "/resources/images/start-marker.png" : "/resources/images/routes/create/spot6.png",
            firstpoint ? new g.Size(29, 50) : new g.Size(6, 6),
            firstpoint ? new g.Point(0, 0) : new g.Point(0, 0),
            firstpoint ? new g.Point(15, 47) : new g.Point(3, 3));

        var marker = new g.Marker({
            position: point,
            map: map,
            icon: pointIcon,
            zIndex: firstpoint ? 1000 : 5,
            visible: true,
            draggable: true
        });

        g.event.addListener(marker, 'dragstart', repositionMarker);
        g.event.addListener(marker, 'drag', repositioningMarker);
        g.event.addListener(marker, 'dragend', repositionedMarker);
        g.event.addListener(marker, 'click', deletePoint);
        /*
        
        g.event.addListener(marker, 'rightclick', openContextMenu);
        */

        return marker;
    }

    function deletePoint(e) {
        if (routeCreatorState.createMode == "edit") {
            var pointToDelete = standardisePoint({ lat: e.latLng.lat(), lng: e.latLng.lng() });

            var deletionIndex = 0;
            routePoints.map((p, id) => {
                if (p.lat == pointToDelete.lat && p.lng == pointToDelete.lng) {
                    routePoints.splice(id, 1);
                    markers.splice(id, 1);
                    deletionIndex = id;

                    if (deletionIndex == 0) {
                        var g = google.maps;
                        var pointIcon = new g.MarkerImage("/resources/images/start-marker.png", new g.Size(29, 50), new g.Point(0, 0), new g.Point(15, 47));
                        markers[0].setIcon(pointIcon);
                        markers[0].setZIndex(1000);
                    }
                }
            });
            this.setMap(null);
            reDrawRoute(routePoints);
            deleteRoutePoint(deletionIndex);
        }
    }

    function repositionMarker(e) {
        movingMarkerPosition = standardisePoint({ lat: e.latLng.lat(), lng: e.latLng.lng() });
        markerIsMoving = true;
    }


    function repositioningMarker(e) {
        
        movingMarkerNewPosition = standardisePoint({ lat: e.latLng.lat(), lng: e.latLng.lng() });
        

        routePoints.map((p, idx) => {
            if (p.lat == movingMarkerPosition.lat && p.lng == movingMarkerPosition.lng) {
                p.lat = movingMarkerNewPosition.lat;
                p.lng = movingMarkerNewPosition.lng;
                p.elevation = null;
                movingMarkerIndex = idx; 
            }
        });

        reDrawRoute(routePoints, true);

        movingMarkerPosition = movingMarkerNewPosition;
    }

    function repositionedMarker() {
        setTimeout(() => { markerIsMoving = false; }, 500);//Set on timeout to avoid ghost clicks
        moveRoutePoint(movingMarkerPosition, movingMarkerIndex);
    }

    function handleMapChanged() {
        mapUpdated({ centre: [map.center.lat(), map.center.lng()], zoom: map.zoom });
    }

    function handleMapVariantChanged() {
        var mapTypeId = map.getMapTypeId();
        mapUpdated({ mapType: { type: "GOOGLE", variant: mapTypeId } });
    }

    function onMapChanged(mapType) {
        mapUpdated({ mapType: mapType });
    }


    return (
        <React.Fragment>
            {
                processing ?
                    <Spinner /> : (

                        <React.Fragment>
                            <div className="create-toolbar col-12">
                                <div className="map-controls row">
                                    <div className="map-title col-6 col-sm-8">
                                        <span className="h4 ml-2" title={routeCreatorState.routeId ? `Edit ${routeCreatorState.routeName}` : "Create"} >
                                            {routeCreatorState.routeId ? `Edit ${routeCreatorState.routeName}` : "Create"}
                                        </span>
                                    </div>
                                    <div className="map-center col-6 col-sm-4">
                                        <div className="input-group mb-0">
                                            <input ref={locationRef} type="text" className="form-control form-control-sm" placeholder="Map Center..." aria-label="Location Search" />
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-search" onClick={onSearch}></span></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="create-map-container">
                                <div className="zoom-controls btn-group" role="group">
                                    <button ref={zoomInRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-plus" /></button>
                                    <button ref={zoomOutRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-minus" /></button>
                                </div>
                                <div className="leaflet-container">
                                    <div key={`${routeCreatorState.plotMode}:${draftRoute.future.length}:${routeCreatorState.createMode}:${mapVariant}`} ref={mapRef} id="google-map"></div>
                                </div>
                            </div>
                        </React.Fragment> 
                    )
            }
        </React.Fragment>
    );

}

/*
 
<div className="input-group-prepend" >
    <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-crosshairs" onClick={onSetUserLocation}></span></button>
</div>
 
 */


CreateRouteGoogleMapView.propTypes =
    {
        mapVariant: PropTypes.string,
        centre: PropTypes.array,
        zoom: PropTypes.number,
        points: PropTypes.array,
        routeCreatorState: PropTypes.object,
        draftRoute: PropTypes.object.isRequired,
        mapUpdated: PropTypes.func.isRequired,
        addRoutePoints: PropTypes.func.isRequired,
        deleteRoutePoint: PropTypes.func.isRequired,
        moveRoutePoint: PropTypes.func.isRequired,
        insertRoutePoint: PropTypes.func.isRequired,
        setReCentreOnLoad: PropTypes.func.isRequired,
        map: PropTypes.object
    }


function mapStateToProps(state) {
    return {
        auth: state.auth,
        draftRoute: state.draftRoute,
        routeCreatorState: state.routeCreatorState
    };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateRouteGoogleMapView);



// WEBPACK FOOTER //
// ./src/components/routes/CreateRouteGoogleMapView.js